export enum PurchaseStates {
  ok = 'OK',
  error = 'ERROR',
  enterPin = 'ENTER_PIN',
  redirect = 'Redirect',
  pending = 'Pending',
  geoBlock = 'GeoBlock',
}
